import React from 'react';
import Icon from '../../../components/AppIcon';


const ContactList = ({
  conversations,
  selectedConversation,
  onSelectConversation,
  searchQuery,
  onSearchChange,
  roleFilter,
  onRoleFilterChange
}) => {
  const roleColors = {
    student: 'bg-primary',
    employer: 'bg-success',
    institution: 'bg-secondary'
  };

  const roleLabels = {
    student: 'Student',
    employer: 'Employer',
    institution: 'Institution'
  };

  return (
    <>
      <div className="p-4 border-b border-border">
        <div className="relative mb-3">
          <Icon
            name="Search"
            size={16}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
          />
          <input
            type="text"
            placeholder="Search conversations..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full pl-10 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>
        <div className="flex gap-2 overflow-x-auto">
          <button
            onClick={() => onRoleFilterChange('all')}
            className={`px-3 py-1.5 rounded-md text-xs font-medium whitespace-nowrap transition-smooth ${
              roleFilter === 'all' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            All
          </button>
          {Object.entries(roleLabels)?.map(([key, label]) => (
            <button
              key={key}
              onClick={() => onRoleFilterChange(key)}
              className={`px-3 py-1.5 rounded-md text-xs font-medium whitespace-nowrap transition-smooth ${
                roleFilter === key
                  ? `${roleColors?.[key]} text-white`
                  : 'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {conversations?.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full p-8 text-center">
            <Icon name="MessageSquare" size={48} className="text-muted-foreground mb-4" />
            <p className="text-muted-foreground">No conversations found</p>
          </div>
        ) : (
          conversations?.map((conversation) => (
            <button
              key={conversation?.id}
              onClick={() => onSelectConversation(conversation)}
              className={`w-full p-4 flex items-start gap-3 hover:bg-muted/50 transition-smooth border-b border-border ${
                selectedConversation?.id === conversation?.id ? 'bg-muted' : ''
              }`}
            >
              <div className="relative flex-shrink-0">
                <img
                  src={conversation?.avatar}
                  alt={conversation?.avatarAlt}
                  className="w-12 h-12 rounded-full object-cover"
                />
                {conversation?.isOnline && (
                  <span className="absolute bottom-0 right-0 w-3 h-3 bg-success border-2 border-card rounded-full" />
                )}
                {conversation?.type === 'group' && (
                  <span className="absolute -bottom-1 -right-1 w-5 h-5 bg-primary text-white text-xs rounded-full flex items-center justify-center">
                    <Icon name="Users" size={12} />
                  </span>
                )}
              </div>
              <div className="flex-1 min-w-0 text-left">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-semibold text-sm text-foreground truncate">
                    {conversation?.name}
                  </h3>
                  <span className="text-xs text-muted-foreground whitespace-nowrap ml-2">
                    {conversation?.lastMessageTime}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground truncate mb-1">
                  {conversation?.lastMessage}
                </p>
                <div className="flex items-center justify-between">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${roleColors?.[conversation?.role]} text-white`}>
                    {roleLabels?.[conversation?.role]}
                  </span>
                  {conversation?.unreadCount > 0 && (
                    <span className="bg-primary text-primary-foreground text-xs font-bold px-2 py-0.5 rounded-full">
                      {conversation?.unreadCount}
                    </span>
                  )}
                </div>
              </div>
            </button>
          ))
        )}
      </div>
    </>
  );
};

export default ContactList;